import React, { useState, useEffect } from 'react';
import OdooService from '../../services/odooService';
import { useNavigate } from "react-router-dom";
import './Login.css';
import ErrorModal from '../../components/ErrorModal/ErrorModal';
import LoadingOverlay from '../../components/LoadingOverlay/LoadingOverlay';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    
    useEffect(() => {
        const usernameInput = document.getElementById('username');
        if (usernameInput) {
            usernameInput.focus();
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!username || !password) {
            setError('Complete usuario y contraseña');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const result = await OdooService.login(username, password);
            if (result.success) {
                navigate("/home");
            } else {
                setError(result.message)
            }
            

        } catch (err) {
            setError('Error de conexión: ' + (err.message || 'Verifique el servidor'));
        } finally {
            setLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && username && password && !loading) {
            handleSubmit(e);
        }
    };

    return (
        <div className="login-screen">
            <div className="login-box">
                <h1>Dimabe Scan</h1>
                <p>Odoo</p>

                <form onSubmit={handleSubmit} className="login-form">
                    <div className="input-group">
                        <label>USUARIO:</label>
                        <input
                            id="username"
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="login-input"
                            placeholder="Ingrese usuario"
                            disabled={loading}
                        />
                    </div>

                    <div className="input-group">
                        <label>CONTRASEÑA:</label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="login-input"
                            placeholder="Ingrese contraseña"
                            disabled={loading}
                        />
                    </div>

                    <button
                        type="submit"
                        className="login-btn"
                        disabled={loading || !username || !password}
                    >
                        {loading ? 'CONECTANDO...' : 'INGRESAR'}
                    </button>
                </form>
                <p>Desarrollado por: Dimabe LTDA</p>
            </div>

            {loading && <LoadingOverlay message="Validando credenciales..." />}

            <ErrorModal message={error} onClose={() => setError("")} />
        </div>
    );
};

export default Login;